import { Colors, dark, darkColors, light } from '../constants';

export const themeColors = (color: Colors) => {
  if (darkColors.includes(color)) {
    return dark;
  }

  return light;
};
